module.exports = __webpack_public_path__ + "static/media/u22.398185b7.png";